import { cellRenderAdminMessageStatus, cellRenderParseDataAndTimeWithSeconds } from '../../../utils/functions';

/** Список полей */
const met1cDataGrid = [
  {
    dataField: 'docId',
    caption: 'ID документа',
    dataType: 'string'
  },
  {
    dataField: 'msgCounter',
    caption: 'ID сообщения',
    dataType: 'string'
  },
  {
    dataField: 'msgDateTime',
    caption: 'Время',
    dataType: 'datetime',
    cellRender: cellRenderParseDataAndTimeWithSeconds
  },
  {
    dataField: 'msgId',
    caption: 'Тип',
    dataType: 'number'
  },
  {
    dataField: 'msgDesc',
    caption: 'Описание типа',
    dataType: 'string'
  },
  {
    dataField: 'msgGuid',
    caption: 'msgGuid',
    dataType: 'string'
  },
  {
    dataField: 'status',
    caption: 'Статус',
    dataType: 'number',
    cellRender: cellRenderAdminMessageStatus
  },
  {
    dataField: 'msgRemark',
    caption: 'msgRemark',
    dataType: 'string'
  },
  {
    dataField: 'modDateTime',
    caption: 'Время изменения',
    dataType: 'date',
    cellRender: cellRenderParseDataAndTimeWithSeconds
  },
  {
    dataField: 'evnCounter',
    caption: 'Идентификатор внутренний',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'clientId',
    caption: 'clientId',
    dataType: 'string'
  }
];

export default met1cDataGrid;
